import type { LucideIcon } from "lucide-react";
import {
  Bath,
  BedDouble,
  ChefHat,
  DoorOpen,
  Flower2,
  Home,
  Image as ImageIcon,
  Layers,
  Sofa,
  Sun,
  Trees,
} from "lucide-react";

export const CHAO_AMBIENTES_UI: {
  key: string;
  label: string;
  icon: LucideIcon;
  /** Cor da faixa no card */
  bar: string;
}[] = [
  { key: "Fachada", label: "Fachada", icon: Home, bar: "bg-slate-600" },
  { key: "Terraço", label: "Terraço", icon: Sun, bar: "bg-amber-500" },
  { key: "Corredor", label: "Corredor", icon: DoorOpen, bar: "bg-slate-400" },
  { key: "Quintal", label: "Quintal", icon: Trees, bar: "bg-emerald-600" },
  { key: "Frente da casa", label: "Frente da casa", icon: Flower2, bar: "bg-teal-500" },
  { key: "Sala", label: "Sala", icon: Sofa, bar: "bg-violet-500" },
  { key: "Quarto 1", label: "Quarto 1", icon: BedDouble, bar: "bg-indigo-500" },
  { key: "Banheiro", label: "Banheiro", icon: Bath, bar: "bg-sky-600" },
  { key: "Quarto 2", label: "Quarto 2", icon: Layers, bar: "bg-indigo-400" },
  { key: "Cozinha", label: "Cozinha", icon: ChefHat, bar: "bg-orange-500" },
];

export const CHAO_AMB_KEYS = CHAO_AMBIENTES_UI.map((a) => a.key);

/** Ambientes sem foto no registro atual (obrigatório para concluir). */
export function listMissingAmbientesForClose(photos: { ambiente: string }[]): string[] {
  const covered = new Set<string>();
  for (const p of photos) {
    const key = matchAmbienteKey(p.ambiente ?? "");
    if (key) covered.add(key);
  }
  return CHAO_AMB_KEYS.filter((k) => !covered.has(k));
}

/** Alinha o valor salvo no servidor com a chave do card (trim, NFC, maiúsculas). */
export function matchAmbienteKey(raw: string): string | null {
  const t = String(raw ?? "")
    .replace(/^\ufeff/, "")
    .trim()
    .normalize("NFC");
  if (!t) return null;
  for (const a of CHAO_AMBIENTES_UI) {
    if (a.key === t) return a.key;
  }
  const tl = t.toLowerCase();
  for (const a of CHAO_AMBIENTES_UI) {
    if (a.key.toLowerCase() === tl) return a.key;
  }
  return null;
}

export function ambienteMeta(key: string) {
  return CHAO_AMBIENTES_UI.find((a) => a.key === key) ?? {
    key,
    label: key,
    icon: ImageIcon,
    bar: "bg-slate-400",
  };
}
